/**@description All the possible keys for accessing LocalStorage */
export enum LocalStorageKeyEnum {
  CostCenterList = 'costCenterList',
  NonBill = 'nonbill',
  User = 'user',
  UserId = 'userId',
  WorkingAs = 'workingAs',
}
